import lazy from 'utils/lazy';

export const NotFound = lazy(() => import('./NotFound'));
